export default __webpack_public_path__ + "static/media/EPS.7fb44597.png";